<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/manager' }"
        >管理后台</el-breadcrumb-item
      >
      <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索栏 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="输入账号" v-model="queryInfo.name"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getManagersList">搜索</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="showAddDialog">添加</el-button>
        </el-col>
      </el-row>

      <!-- 管理员列表 -->
      <el-table border stripe :data="managers">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="账号" prop="mg_name"></el-table-column>
        <el-table-column label="电话" prop="mg_mobile"></el-table-column>
        <el-table-column label="邮箱" prop="mg_email"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeById(scope.row.mg_id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加or编辑文章弹出层 -->
    <el-dialog
      :visible.sync="dialogVisble"
      width="50%"
      @close="addOrEditDialogClosed"
    >
      <el-form
        ref="addOrEditFormRef"
        :model="addOrEditForm"
        :rules="addOrEditFormRules"
        label-width="180px"
      >
        <el-form-item label="管理员账号">
          <el-input v-model="addOrEditForm.mg_name"></el-input>
        </el-form-item>
        <el-form-item label="管理员密码">
          <el-input
            v-model="addOrEditForm.mg_pwd"
            placeholder="要修改信息必须输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话号码">
          <el-input v-model="addOrEditForm.mg_mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="addOrEditForm.mg_email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisble = false">取 消</el-button>
        <el-button type="primary" @click="addOrEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Manager",
  data() {
    return {
      // 控制添加or修改框显示与隐藏
      dialogVisble: false,
      // 添加或修改的表单数据
      addOrEditForm: {
        id: -1,
        mg_name: "",
        mg_pwd: "",
        mg_mobile: "",
        mg_email: "",
      },
      // 标识是添加还是编辑
      isEdit: false,
      //   表单验证规则对象
      addOrEditFormRules: {
        mg_name: [
          { required: true, message: "请输入账号名称", trigger: "blur" },
        ],
        mg_pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // mg_mobile: [
        //   { required: true, message: "请输入电话号码", trigger: "blur" },
        // ],
        // mg_email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
      //   管理员列表
      managers: [],
      // 查询参数对象
      queryInfo: {
        name: "",
        pagenum: 1,
        pagesize: 10,
      },
      // 总数据条数
      total: 0,
    };
  },
  created() {
    this.getManagersList();
  },
  methods: {
    // 添加按钮弹出层
    showAddDialog() {
      this.dialogVisble = true;
    },
    // 关闭弹出层
    addOrEditDialogClosed() {
      this.$refs.addOrEditFormRef.resetFields();
      this.addOrEditForm.mg_name = "";
      this.addOrEditForm.mg_pwd = "";
      this.addOrEditForm.mg_mobile = "";
      this.addOrEditForm.mg_email = "";
    },
    // 弹层添加和修改按钮事件
    addOrEdit() {
      if (!this.isEdit) {
        this.addManager();
      } else {
        this.editManager();
      }
    },
    // 添加
    addManager() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.post("manager", {
          mg_name: this.addOrEditForm.mg_name,
          mg_pwd: this.addOrEditForm.mg_pwd,
          mg_mobile: this.addOrEditForm.mg_mobile,
          mg_email: this.addOrEditForm.mg_email,
        });
        if (res.meta.status !== 201) {
          return this.$message.error("添加失败！");
        }
        this.$message.success("添加成功！");
        this.getManagersList();
        this.dialogVisble = false;
      });
    },
    // 修改
    editManager() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.put(
          `manager/${this.addOrEditForm.id}`,
          {
            mg_name: this.addOrEditForm.mg_name,
            mg_pwd: this.addOrEditForm.mg_pwd,
            mg_mobile: this.addOrEditForm.mg_mobile,
            mg_email: this.addOrEditForm.mg_email,
          }
        );
        if (res.meta.status !== 200) {
          return this.$message.error("修改失败！");
        }
        this.$message.success("修改成功！");
        this.getManagersList();
        this.dialogVisble = false;
      });
    },
    // 根据分页获取对应的管理员列表
    async getManagersList() {
      const { data: res } = await this.$http.get("manager", {
        params: this.queryInfo,
      });

      if (res.meta.status !== 200) {
        return this.$message.error("获取管理员列表失败！");
      }
      this.$message.success("获取管理员列表成功！");
      console.log(res.data);
      this.managers = res.data.managers;
      this.total = res.data.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getManagersList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getManagersList();
    },
    // 删除管理员
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该文章, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }
      const { data: res } = await this.$http.delete(`manager/${id}`);
      if (res.meta.status !== 200) {
        console.log(res.meta.msg);
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getManagersList();
    },
    showEditDialog(row) {
      this.dialogVisble = true;
      this.isEdit = true;
      this.addOrEditForm.id = row.mg_id;
      this.addOrEditForm.mg_name = row.mg_name;
      //   this.addOrEditForm.mg_pwd = row.mg_pwd;
      this.addOrEditForm.mg_mobile = row.mg_mobile;
      this.addOrEditForm.mg_email = row.mg_email;
    },
  },
};
</script>
<style scoped>
</style>